export default __webpack_public_path__ + "static/supportSystemListingImage1-de322762cbc1be5542adbb24ab7ecfe4.webp";